import React, { useState, useEffect } from "react";
import { adminCreateSubCategory, adminUpdateSubCategory } from "../api/admin";
import { toast } from "react-toastify";

const SubCategoryForm = ({ parentCategoryId, subcategory, onSuccess, onCancel }) => {
    const [name, setName] = useState("");
    const [status, setStatus] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (subcategory) {
            setName(subcategory.sub_category_name || subcategory.subcategory_name || "");
            // Prefer 'status' if 'sub_status' is missing (matches user JSON)
            const resolvedStatus = subcategory.status !== undefined ? subcategory.status : 
                                  subcategory.sub_status !== undefined ? subcategory.sub_status : true;
            setStatus(resolvedStatus === true || resolvedStatus === 1 || String(resolvedStatus).toLowerCase() === 'true');
        } else {
            setName("");
            setStatus(true);
        }
    }, [subcategory]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) return;

        setLoading(true);
        // Use URLSearchParams for application/x-www-form-urlencoded as requested
        const params = new URLSearchParams();
        params.append("category_id", parentCategoryId);
        params.append("sub_category_name", name);
        params.append("sub_status", status ? "true" : "false");

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

            if (subcategory) {
                const id = subcategory.id || subcategory._id || subcategory.subcategory_id;
                await adminUpdateSubCategory(id, params, config);
                toast.success("Subcategory updated successfully! ✨");
            } else {
                await adminCreateSubCategory(params, config);
                toast.success("Subcategory created successfully! 🛡️");
            }
            onSuccess();
        } catch (error) {
            console.error("Error saving subcategory:", error);
            toast.error(error.response?.data?.message || "Failed to save subcategory. ❌");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="admin-form">
            <div className="form-body">
                <div className="form-grid">
                    <div className="form-group">
                        <label>Subcategory Name <span className="required-star">*</span></label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="e.g. Wireless Headphones"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Status</label>
                        <div 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '15px', 
                                marginTop: '8px',
                                background: '#f8f9fa',
                                padding: '12px',
                                borderRadius: '10px',
                                width: 'fit-content',
                                border: '1px solid #eee'
                            }}
                        >
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: 0 }}>
                                <input 
                                    type="radio" 
                                    name="sub_status" 
                                    checked={status === true} 
                                    onChange={() => setStatus(true)} 
                                />
                                <span style={{ fontWeight: status === true ? '600' : '400', color: status === true ? '#28a745' : '#666' }}>Active</span>
                            </label>
                            
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', margin: 0 }}>
                                <input 
                                    type="radio" 
                                    name="sub_status" 
                                    checked={status === false} 
                                    onChange={() => setStatus(false)} 
                                />
                                <span style={{ fontWeight: status === false ? '600' : '400', color: status === false ? '#dc3545' : '#666' }}>Inactive</span>
                            </label>
                        </div>
                    </div>
                </div>
                
                <div className="form-footer">
                    <button type="submit" className="btn-submit" disabled={loading}>
                        {loading ? "Saving..." : (subcategory ? "Update Subcategory" : "Create Subcategory")}
                    </button>
                    <button
                        type="button"
                        className="btn-cancel"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </form>
    );
};

export default SubCategoryForm;
